import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/VegetarianFilled.tsx
import React from "react";
var SvgVegetarianFilled, VegetarianFilled_default;
var init_VegetarianFilled = __esm({
  "src/icons/VegetarianFilled.tsx"() {
    SvgVegetarianFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M20.998 3v2c0 9.627-5.373 14-12 14H7.096c.212-3.012 1.15-4.835 3.598-7.001 1.204-1.065 1.102-1.68.509-1.327C7.119 13.102 5.09 16.386 5 21.63l-.003.37h-2c0-1.363.116-2.6.346-3.732-.23-1.294-.346-3.05-.346-5.268 0-5.523 4.477-10 10-10 2 0 4 1 8 0Z"
        }
      )
    );
    VegetarianFilled_default = SvgVegetarianFilled;
  }
});

export {
  VegetarianFilled_default,
  init_VegetarianFilled
};
